import { gql } from "@apollo/client";

export const TASK_UPDATED_SUBSCRIPTION = gql`
  subscription TaskUpdated($projectIds: [String!]) {
    taskUpdated(projectIds: $projectIds) {
      eventType
      taskId
      projectId
      oldStatus
      newStatus
      version
      title
      updatedByUserId
      timestamp
      snapshot {
        id
        title
        status
        version
        parentId
        sectionId
        procurementPackageId
        plotId
        projectId
        dueDate
        responsibleUserId
        taskType
        updatedAt
      }
    }
  }
`;
